import { Skeleton } from "@/components/ui/skeleton";

const AuthSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Warning Banner */}
      <div className="h-10 bg-muted" />
      
      {/* Navigation */}
      <div className="h-16 border-b border-border" />
      
      <main className="container mx-auto px-4 py-12 flex items-center justify-center min-h-[calc(100vh-10rem)]">
        <div className="w-full max-w-md">
          {/* Logo/Brand */}
          <div className="text-center mb-8">
            <Skeleton className="h-12 w-12 mx-auto mb-4 rounded-lg" />
            <Skeleton className="h-8 w-48 mx-auto mb-2" />
            <Skeleton className="h-5 w-64 mx-auto" />
          </div>

          {/* Auth Card */}
          <div className="bg-card rounded-xl border border-border p-8">
            {/* Tabs (Login/Register) */}
            <div className="flex gap-2 mb-6">
              <Skeleton className="h-10 flex-1 rounded-lg" />
              <Skeleton className="h-10 flex-1 rounded-lg" />
            </div>

            {/* Form Fields */}
            <div className="space-y-4">
              {/* Email */}
              <div>
                <Skeleton className="h-4 w-16 mb-2" />
                <Skeleton className="h-10 w-full" />
              </div>

              {/* Password */}
              <div>
                <Skeleton className="h-4 w-20 mb-2" />
                <Skeleton className="h-10 w-full" />
              </div>

              {/* Forgot Password Link */}
              <div className="flex justify-end">
                <Skeleton className="h-4 w-32" />
              </div>

              {/* Submit Button */}
              <Skeleton className="h-12 w-full rounded-lg" />
            </div>

            {/* Divider */}
            <div className="flex items-center gap-4 my-6">
              <Skeleton className="h-px flex-1" />
              <Skeleton className="h-4 w-8" />
              <Skeleton className="h-px flex-1" />
            </div>

            {/* Social Login Buttons */}
            <div className="space-y-3">
              <Skeleton className="h-10 w-full rounded-lg" />
              <Skeleton className="h-10 w-full rounded-lg" />
            </div>

            {/* Terms Text */}
            <div className="mt-6 text-center">
              <Skeleton className="h-4 w-3/4 mx-auto" />
            </div>
          </div>

          {/* Bottom Links */}
          <div className="mt-6 text-center">
            <Skeleton className="h-4 w-48 mx-auto" />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthSkeleton;
